const initialState = {
  graph1: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GRAPH1':
      const { graph1 } = action;
      return {
        ...state,
        graph1,
      };
    default:
      return state;
  }
};

export const setGraph1 = (
  graph1,
) => ({
  type: 'GRAPH1',
  graph1,
});
